import api from '@pray/shared/utils/api';

import type { AnalyticsMetric, IndividualMetricsData } from './types/analytics';

export type GetIndividualMetricsParams = {
  experimentId: string;
  instanceName?: string;
  experimentListNumber: number;
  startDate: string;
  endDate: string;
  metrics: AnalyticsMetric[];
};

export type GetIndividualMetricsResponse = {
  data: IndividualMetricsData;
};

/**
 * Fetches individual metrics data for an experiment.
 * Unlike funnel, these metrics are independent with no dependencies.
 */
export async function getIndividualMetrics({
  experimentId,
  instanceName,
  experimentListNumber,
  startDate,
  endDate,
  metrics,
}: GetIndividualMetricsParams): Promise<IndividualMetricsData> {
  if (!experimentId) throw new Error('Experiment ID is required');
  if (!metrics.length) throw new Error('At least one metric is required');

  const url = `/web/studio/experiments/${experimentId}/analytics/metrics`;
  const params: Record<string, string | number> = {
    experiment_list_number: experimentListNumber,
    start_date: startDate,
    end_date: endDate,
    metrics: metrics.join(','),
  };

  if (instanceName) {
    params.instance_name = instanceName;
  }

  const response = await api.executeGetRequest<GetIndividualMetricsResponse>(url, params);

  return response.data.data;
}
